import { Component } from '@angular/core';

import { UploadComponent } from '@camelot/form-input';
import { InputUpload, InputUploadValue } from '@camelot/form-model';
import { TranslatePipe } from '@camelot/translation';
import { LayoutFullPanelComponent } from '@camelot/ui';
import { CamBaseModal } from '@camelot/utils';

import { CamTranslationProject } from '../../../translation.service';

export interface AttachmentsResult {
  result: InputUploadValue[];
}

@Component({
  imports: [LayoutFullPanelComponent, TranslatePipe, UploadComponent],
  selector: 'cam-document-attachment-modal',
  styleUrl: './document-attachment-modal.component.scss',
  templateUrl: './document-attachment-modal.component.html',
})
export class DocumentAttachmentModal extends CamBaseModal<void, AttachmentsResult | null> {
  public uploadInput = new InputUpload({
    confirmButton: true,
  });

  constructor() {
    super();
    CamTranslationProject.getInstance();
    this.uploadInput.changeValue$.subscribe({
      next: ids => this.onSave(ids),
    });
  }

  public cancel() {
    this.modalState()?.completed(null);
    this.closeEvent.emit(null);
  }

  public onSave(result: InputUploadValue[]) {
    this.modalState()?.completed({ result });
    this.closeEvent.emit({ result });
  }
}
